/****************************************************************
 * jotai state and atoms for the accounts listing
 ***************************************************************/

import { atom } from 'jotai';
import callApi from 'lib/callApi';
import { companyIdAtom } from 'views/state';

export enum IntegrationState {
  None = 'None',
  CreatingAccount = 'Creating Account',
  FetchingRepositories = 'Fetching Repositories',
  RepositoriesListed = 'Repositories Listed',
  Failed = 'Failed',
}

export interface AccountCreateResponseType {
  id?: number;
  error?: string;
  success?: string;
}

export const hostTypeAtom = atom<string | undefined>(undefined);

export const authCodeAtom = atom<string | undefined>(undefined);

export const integrationStateAtom = atom<IntegrationState>(
  IntegrationState.None,
);

export const createAccountResponseAtom = atom(async (get) => {
  const companyId = get(companyIdAtom);
  const hostType = get(hostTypeAtom);
  const authCode = get(authCodeAtom);
  const integrationState = get(integrationStateAtom);

  if (
    companyId &&
    companyId !== -1 &&
    hostType &&
    authCode &&
    integrationState === IntegrationState.CreatingAccount
  ) {
    let response: any = undefined;
    try {
      const data = {
        company_id: companyId,
        host_type: hostType,
        code: authCode,
      };

      response = await callApi('sast/accounts/create/', 'POST', data);
      return response?.data as AccountCreateResponseType;
    } catch (err) {
      let error: any = err as any;
      console.error('ERROR in createAccountResponseAtom:', error);
      if (error?.data) {
        return error?.data as AccountCreateResponseType;
      }
      return { error: error } as AccountCreateResponseType;
    }
  }
});
